import { MouseEvent, ReactNode } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
import { t } from '@lingui/core/macro'

interface ColumnDialogProps {
  open: boolean
  title: string
  handleCloseDialog: (e: MouseEvent<HTMLButtonElement>) => void
  handleConfirmDialog: (e: MouseEvent<HTMLButtonElement>) => void
  confirmLabel?: string
  children: ReactNode
}

export function ColumnDialog({
  children,
  open,
  title,
  handleCloseDialog,
  handleConfirmDialog,
  confirmLabel,
}: ColumnDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>{title}</DialogTitle>
      {children}
      <DialogActions>
        <Button name="cancel" onClick={handleCloseDialog}>
          {t`Cancel`}
        </Button>
        <Button variant="contained" name="confirm" onClick={handleConfirmDialog} color="primary">
          {confirmLabel ?? t`Rename`}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
